import React, { useState, useEffect, useCallback } from 'react';
import colaboradorService from '../../services/colaborador.service';
import usuarioService from '../../services/usuario.service';                  // r130: pra buscar foto do usuário vinculado
import BtnIcone from '../../components/BtnIcone';
import SePode from '../../components/SePode';   // r88: botões condicionais por permissão
import Modal from '../../components/Modal';
import GridValores from '../../components/GridValores';
import BrowseHeader from '../../components/BrowseHeader';                    // r106
import { iconeDaRotina } from '../../constants/iconesRotinas';               // r106

const COR = {
  azul:     '#003399',
  azulBg:   '#eff6ff',
  borda:    '#e8eaed',
  texto:    '#1a1a2e',
  muted:    '#888',
  branco:   '#fff',
  verde:    '#1D9E75',
  verdeBg:  '#f0fff4',
  vermelho: '#e53935',
  vermBg:   '#fff0f0',
  amarelo:  '#d97706',
  amlBg:    '#fffbeb',
  cinzaBg:  '#fafbfc',
};

const inputStyle = {
  width: '100%', height: '36px', padding: '0 10px',
  border: `1px solid ${COR.borda}`, borderRadius: '5px',
  fontSize: '13px', boxSizing: 'border-box',
  backgroundColor: COR.branco, color: COR.texto, outline: 'none',
  // r129 item 1: fonte Manrope nos selects nativos (não herdam por default)
  fontFamily: "'Manrope', sans-serif",
};

const selectStyle = { ...inputStyle, cursor: 'pointer' };

const textareaStyle = {
  width: '100%', padding: '8px 10px',
  border: `1px solid ${COR.borda}`, borderRadius: '5px',
  fontSize: '13px', boxSizing: 'border-box',
  backgroundColor: COR.branco, color: COR.texto,
  outline: 'none', resize: 'vertical', minHeight: '80px',
  fontFamily: "'Manrope', sans-serif",
};

// ─── UFs brasileiras ──────────────────────────────────────────────────────────
const UFS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG',
             'PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

// ─── r130: SVGs das seções e chevron ──────────────────────────────────────────
const SvgVinculo = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  </svg>
);
const SvgPessoa = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);
const SvgContato = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z"/>
  </svg>
);
const SvgFuncional = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
  </svg>
);
const SvgFinanceiro = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="1" x2="12" y2="23"/>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
  </svg>
);
const SvgValores = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/>
    <line x1="12" y1="6" x2="12" y2="18"/>
  </svg>
);
// Chevron do combo (mesmo padrão pra abrir/fechar)
const SvgChevron = ({ size = 14, color = 'currentColor', aberto }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
       style={{
         transform: aberto ? 'rotate(180deg)' : 'rotate(0deg)',
         transition: 'transform 0.15s',
       }}>
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

// ─── r129: helpers ────────────────────────────────────────────────────────────
// Máscara CPF
function formatarCpf(valor) {
  const apenasNum = String(valor || '').replace(/\D/g, '').slice(0, 11);
  const len = apenasNum.length;
  if (len <= 3)  return apenasNum;
  if (len <= 6)  return `${apenasNum.slice(0, 3)}.${apenasNum.slice(3)}`;
  if (len <= 9)  return `${apenasNum.slice(0, 3)}.${apenasNum.slice(3, 6)}.${apenasNum.slice(6)}`;
  return `${apenasNum.slice(0, 3)}.${apenasNum.slice(3, 6)}.${apenasNum.slice(6, 9)}-${apenasNum.slice(9, 11)}`;
}
function limparCpf(valor) {
  return String(valor || '').replace(/\D/g, '').slice(0, 11);
}
// Normaliza datas vindas do backend (pode vir ISO completa) pra YYYY-MM-DD
// usado em <input type="date">
function dataParaInput(d) {
  if (!d) return '';
  const s = String(d);
  // Já no formato YYYY-MM-DD ou começa por isso → pega os 10 primeiros
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  // Tenta Date()
  const dt = new Date(s);
  if (isNaN(dt)) return '';
  const yyyy = dt.getFullYear();
  const mm   = String(dt.getMonth() + 1).padStart(2, '0');
  const dd   = String(dt.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

// r151: máscara CEP no formato 99.999-999 (8 dígitos: 2 + . + 3 + - + 3)
function mascararCep(valor) {
  const nums = String(valor || '').replace(/\D/g, '').slice(0, 8);
  if (nums.length <= 2) return nums;
  if (nums.length <= 5) return `${nums.slice(0, 2)}.${nums.slice(2)}`;
  return `${nums.slice(0, 2)}.${nums.slice(2, 5)}-${nums.slice(5)}`;
}
function limparCep(valor) {
  return String(valor || '').replace(/\D/g, '').slice(0, 8);
}

// r151: máscara telefone fixo no formato 9999-9999 (8 dígitos: 4 + - + 4)
function mascararTelefone(valor) {
  const nums = String(valor || '').replace(/\D/g, '').slice(0, 8);
  if (nums.length <= 4) return nums;
  return `${nums.slice(0, 4)}-${nums.slice(4)}`;
}
function limparTelefone(valor) {
  return String(valor || '').replace(/\D/g, '').slice(0, 8);
}

// ─── Status pill ──────────────────────────────────────────────────────────────
function StatusPill({ status }) {
  const ativo = status === 'A';
  const cor = ativo ? COR.verde : COR.amarelo;
  return (
    <span style={{
      display: 'inline-block', padding: '2px 10px',
      borderRadius: '20px', fontSize: '12px', fontWeight: '500',
      backgroundColor: ativo ? COR.verdeBg : COR.amlBg,
      color: cor,
      border: `1px solid ${cor}`,           // r108: borda na cor da fonte
    }}>{ativo ? 'Ativo' : 'Inativo'}</span>
  );
}

// ─── r129 item 8: Badges Vendedor e Resp. Técnico no padrão StatusPill ──────
// 12/500, borda na cor da fonte, Title Case
function VendedorBadge({ vendedor }) {
  if (!vendedor) return null;
  return (
    <span style={{
      display: 'inline-block', padding: '2px 10px',
      borderRadius: '20px', fontSize: '12px', fontWeight: '500',
      backgroundColor: COR.azulBg, color: COR.azul,
      border: `1px solid ${COR.azul}`,
      marginLeft: '6px',
    }}>Vendedor</span>
  );
}

function RespTecBadge({ respTec }) {
  if (!respTec) return null;
  return (
    <span style={{
      display: 'inline-block', padding: '2px 10px',
      borderRadius: '20px', fontSize: '12px', fontWeight: '500',
      backgroundColor: COR.verdeBg, color: COR.verde,
      border: `1px solid ${COR.verde}`,
      marginLeft: '6px',
    }}>Resp. Técnico</span>
  );
}

// ─── r129 itens 3 e 4: Campo (espaçamento maior, label mais perto) ───────────
function Campo({ label, children, obrigatorio, metade }) {
  return (
    <div style={{ marginBottom: '24px', width: metade ? 'calc(50% - 5px)' : '100%' }}>
      <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: COR.muted, marginBottom: '2px' }}>
        {label}{obrigatorio && <span style={{ color: COR.vermelho }}> *</span>}
      </label>
      {children}
    </div>
  );
}

function Linha({ children }) {
  return <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>{children}</div>;
}

// ─── r129/r130: Avatar pequeno do usuário vinculado ──────────────────────────
// r130 item 1: tamanho 30px (igual Sidebar), label "Avatar" centralizada
// r130 item 2: usa o usuário completo (recebido via buscarPorId) que tem foto
function AvatarPequeno({ usuario }) {
  const nomeRef = usuario?.nome_amigavel || usuario?.nome || '';
  const iniciais = nomeRef
    .split(' ').filter(Boolean).map(p => p[0]).slice(0, 2).join('').toUpperCase() || '?';

  const fotoUrl = (() => {
    if (!usuario?.foto) return '';
    if (usuario.foto.startsWith('http')) return usuario.foto;
    const base = process.env.REACT_APP_API_BASE ? process.env.REACT_APP_API_BASE.replace(/\/api$/, '') : '';
    return `${base}${usuario.foto}`;
  })();

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      gap: '2px',
    }}>
      <label style={{ fontSize: '12px', fontWeight: '600', color: COR.muted }}>
        Avatar
      </label>
      <div style={{
        // r131: 39px (+30% sobre 30 do r130)
        // r132: 58px (+50% sobre 39 do r131)
        width: '58px', height: '58px', borderRadius: '50%',
        backgroundColor: COR.azulBg,
        border: `1px solid ${COR.azul}`,
        color: COR.azul, fontSize: '18px', fontWeight: '700',
        overflow: 'hidden',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundImage: fotoUrl ? `url(${fotoUrl})` : 'none',
        backgroundSize: 'cover', backgroundPosition: 'center',
      }}>
        {!fotoUrl && iniciais}
      </div>
    </div>
  );
}

// ─── r129/r130: Seção expansível (padrão CRM/Negócios) ──────────────────────
// r130: ganha prop `icone` (componente SVG) e usa chevron SVG no lugar de ▲▼
function Secao({ icone: Icone, titulo, aberta, onToggle, children, fixa }) {
  const estaAberta = fixa ? true : aberta;
  return (
    <div style={{
      border: `1px solid ${COR.borda}`, borderRadius: '6px',
      marginBottom: '12px', overflow: 'hidden', backgroundColor: COR.branco,
    }}>
      <div
        onClick={fixa ? undefined : onToggle}
        style={{
          padding: '12px 16px',
          backgroundColor: estaAberta ? COR.azulBg : COR.cinzaBg,
          borderBottom: estaAberta ? `1px solid ${COR.borda}` : 'none',
          cursor: fixa ? 'default' : 'pointer',
          userSelect: 'none',
          display: 'flex', alignItems: 'center', gap: '10px',
          transition: 'background-color 0.15s',
        }}
      >
        {/* r130 item 3: ícone SVG antes do título */}
        {Icone && (
          <span style={{
            display: 'inline-flex',
            color: estaAberta ? COR.azul : COR.muted,
          }}>
            <Icone size={18} />
          </span>
        )}
        <span style={{
          flex: 1,
          fontSize: '14px',
          fontWeight: '700',
          color: estaAberta ? COR.azul : COR.texto,
        }}>
          {titulo}
        </span>
        {/* r130 item 4: chevron SVG (mesmo do combo) em vez de ▲▼ */}
        {!fixa && (
          <span style={{
            display: 'inline-flex',
            color: COR.muted,
          }}>
            <SvgChevron aberto={estaAberta} size={16} />
          </span>
        )}
      </div>
      {estaAberta && <div style={{ padding: '16px' }}>{children}</div>}
    </div>
  );
}

// ─── Form vazio ───────────────────────────────────────────────────────────────
const FORM_VAZIO = {
  usuario_id: '', nome: '', nome_amigavel: '', cpf: '', nascimento: '',
  logradouro: '', numero: '', complemento: '', bairro: '',
  municipio: '', uf: '', cep: '', ddd: '', telefone: '',
  email_alpha: '', email_pessoal: '', funcao: '',
  rem_fixa: '', vlr_hora: '', comissao: '',
  vendedor: false, resp_tecnico: false,
  status: 'A', dados_bancarios: '', contato_emergencia: '',
  // r129 item 10: novos campos pra Dados Funcionais
  data_inicio: '', data_fim: '',
};

// ─── Componente principal ─────────────────────────────────────────────────────
function ColaboradoresPage() {
  const [colaboradores, setColaboradores]   = useState([]);
  const [usuariosDisp, setUsuariosDisp]     = useState([]);
  const [carregando, setCarregando]         = useState(true);
  const [busca, setBusca]                   = useState('');
  const [ordenacao, setOrdenacao]           = useState({ campo: 'nome', dir: 'asc' });

  const [painel, setPainel]                 = useState(null);
  const [selecionado, setSelecionado]       = useState(null);
  const [abaAtiva, setAbaAtiva]             = useState('dados');
  const [form, setForm]                     = useState(FORM_VAZIO);
  const [salvando, setSalvando]             = useState(false);
  const [erroPainel, setErroPainel]         = useState('');
  const [sucessoPainel, setSucessoPainel]   = useState('');

  // r129 item 7: estado das seções expansíveis. Vínculo e Dados Pessoais são fixas
  // (sempre abertas). As demais começam fechadas conforme solicitado.
  const [secoes, setSecoes] = useState({
    dadosPessoais: true,    // r131: começa aberta (campos essenciais)
    contato:       false,
    funcionais:    false,
    financeiros:   false,
  });
  const toggleSec = (k) => setSecoes(s => ({ ...s, [k]: !s[k] }));

  // r130 item 2: usuário completo (com foto) do usuário vinculado.
  // Buscado via usuarioService.buscarPorId pra garantir que tem a foto,
  // já que o endpoint /colaboradores/usuarios-disponiveis pode não retornar foto.
  const [usuarioVinculadoCompleto, setUsuarioVinculadoCompleto] = useState(null);

  // r131 item 3: modal de Valores agora é sobreposto (não é mais seção do form)
  const [modalValores, setModalValores] = useState(false);

  // ── Carregar ─────────────────────────────────────────────────────────────────
  const carregar = useCallback(async () => {
    try {
      setCarregando(true);
      const lista = await colaboradorService.listar();
      setColaboradores(lista);
    } catch {
      setColaboradores([]);
    } finally {
      setCarregando(false);
    }
  }, []);

  const carregarUsuarios = useCallback(async (usuarioIdAtual = null) => {
    try {
      const usuarios = await colaboradorService.listarUsuariosColaborador(usuarioIdAtual);
      setUsuariosDisp(usuarios);
    } catch {
      setUsuariosDisp([]);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  // r130 item 2: sempre que mudar o usuário vinculado, busca dados completos
  // (com foto). Como o endpoint /usuarios/:id retorna foto, garantimos
  // que o avatar apareça mesmo se o listar simplificado não traga.
  useEffect(() => {
    let cancelado = false;
    async function buscar() {
      if (!form.usuario_id) {
        setUsuarioVinculadoCompleto(null);
        return;
      }
      try {
        const u = await usuarioService.buscarPorId(form.usuario_id);
        if (!cancelado) setUsuarioVinculadoCompleto(u);
      } catch {
        if (!cancelado) setUsuarioVinculadoCompleto(null);
      }
    }
    buscar();
    return () => { cancelado = true; };
  }, [form.usuario_id]);

  // ── Filtro e ordenação ───────────────────────────────────────────────────────
  const listaFiltrada = colaboradores
    .filter(c => {
      const q = busca.toLowerCase();
      return !q
        || c.nome.toLowerCase().includes(q)
        || (c.nome_amigavel || '').toLowerCase().includes(q)
        || (c.cpf || '').includes(q)
        || (c.email_alpha || '').toLowerCase().includes(q)
        || (c.funcao || '').toLowerCase().includes(q);
    })
    .sort((a, b) => {
      const va = (a[ordenacao.campo] || '').toString().toLowerCase();
      const vb = (b[ordenacao.campo] || '').toString().toLowerCase();
      return ordenacao.dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
    });

  const toggleOrdem = (campo) =>
    setOrdenacao(o => ({ campo, dir: o.campo === campo && o.dir === 'asc' ? 'desc' : 'asc' }));

  const setaCabecalho = (campo) => {
    if (ordenacao.campo !== campo) return ' ↕';
    return ordenacao.dir === 'asc' ? ' ↑' : ' ↓';
  };

  // ── Normaliza booleano vindo da API (BIT do SQL Server vira 0/1) ────────────
  const sanitizarVendedor = (v) => v === true || v === 1 || v === '1';
  const sanitizarBool     = (v) => v === true || v === 1 || v === '1';

  // ── Ações do painel ──────────────────────────────────────────────────────────
  const abrirNovo = () => {
    setForm(FORM_VAZIO);
    setSelecionado(null);
    setAbaAtiva('dados');
    setErroPainel(''); setSucessoPainel('');
    carregarUsuarios(null);
    setPainel('novo');
  };

  const abrirVisualizar = (c) => {
    setSelecionado(c);
    setForm({
      ...FORM_VAZIO, ...c,
      vendedor:    sanitizarVendedor(c.vendedor),
      resp_tecnico:sanitizarBool(c.resp_tecnico),
      // r129 item 6: normaliza datas do backend (podem vir como ISO)
      nascimento:  dataParaInput(c.nascimento),
      data_inicio: dataParaInput(c.data_inicio),
      data_fim:    dataParaInput(c.data_fim),
      cpf:         limparCpf(c.cpf),
    });
    setAbaAtiva('dados');
    setErroPainel(''); setSucessoPainel('');
    carregarUsuarios(c.usuario_id);
    setPainel('visualizar');
  };

  const abrirEditar = (c) => {
    setSelecionado(c);
    setForm({
      ...FORM_VAZIO, ...c,
      vendedor:    sanitizarVendedor(c.vendedor),
      resp_tecnico:sanitizarBool(c.resp_tecnico),
      // r129 item 6: normaliza datas do backend (podem vir como ISO)
      nascimento:  dataParaInput(c.nascimento),
      data_inicio: dataParaInput(c.data_inicio),
      data_fim:    dataParaInput(c.data_fim),
      cpf:         limparCpf(c.cpf),
    });
    setAbaAtiva('dados');
    setErroPainel(''); setSucessoPainel('');
    carregarUsuarios(c.usuario_id);
    setPainel('editar');
  };

  const fecharPainel = () => { setPainel(null); setSelecionado(null); };

  const handleCampo = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const recarregarSelecionado = useCallback(async () => {
    if (!selecionado?.id) { await carregar(); return; }
    try {
      const [lista] = await Promise.all([colaboradorService.listar()]);
      setColaboradores(lista);
      const atualizado = lista.find(x => x.id === selecionado.id);
      if (atualizado) setForm(f => ({
        ...f, ...atualizado,
        vendedor:    sanitizarVendedor(atualizado.vendedor),
        resp_tecnico:sanitizarBool(atualizado.resp_tecnico),
        nascimento:  dataParaInput(atualizado.nascimento),
        data_inicio: dataParaInput(atualizado.data_inicio),
        data_fim:    dataParaInput(atualizado.data_fim),
        cpf:         limparCpf(atualizado.cpf),
      }));
    } catch { await carregar(); }
  }, [carregar, selecionado]);

  // Ao selecionar um usuário no combo, preenche Nome, Nome Amigável, E-mail, CPF
  // e Nascimento — apenas se estiverem vazios
  const handleUsuarioVinculo = (e) => {
    const usuarioId = e.target.value;
    setForm(f => ({ ...f, usuario_id: usuarioId }));

    if (!usuarioId) return;

    const usuarioSel = usuariosDisp.find(u => u.id === usuarioId);
    if (!usuarioSel) return;

    setForm(f => ({
      ...f,
      usuario_id: usuarioId,
      nome:          !f.nome.trim()          ? (usuarioSel.nome           || '') : f.nome,
      nome_amigavel: !f.nome_amigavel.trim() ? (usuarioSel.nome_amigavel  || '') : f.nome_amigavel,
      email_alpha:   !f.email_alpha.trim()   ? (usuarioSel.email          || '') : f.email_alpha,
      // r129 item 2: cpf vem como dígitos no banco; mantém só dígitos no form
      cpf:           !f.cpf.trim()           ? limparCpf(usuarioSel.cpf || '')  : f.cpf,
      // r129 item 6: nascimento do backend pode vir como ISO (2000-01-15T03:00:00.000Z).
      // Normaliza pra YYYY-MM-DD pro <input type="date"> exibir.
      nascimento:    !f.nascimento           ? dataParaInput(usuarioSel.nascimento) : f.nascimento,
    }));
  };

  // ── Bloquear / ativar ────────────────────────────────────────────────────────
  const alterarStatus = async (c) => {
    const novoStatus = c.status === 'A' ? 'I' : 'A';
    try {
      await colaboradorService.alterarStatus(c.id, novoStatus);
      await carregar();
    } catch { alert('Erro ao alterar status.'); }
  };

  // ── Salvar ───────────────────────────────────────────────────────────────────
  const salvar = async () => {
    setErroPainel('');
    if (!form.usuario_id)             return setErroPainel('Usuário vinculado é obrigatório.');
    if (!form.nome.trim())            return setErroPainel('Nome é obrigatório.');
    if (!form.nome_amigavel.trim())   return setErroPainel('Nome Amigável é obrigatório.');
    if (!form.cpf.trim())             return setErroPainel('CPF é obrigatório.');
    if (!form.nascimento)             return setErroPainel('Data de nascimento é obrigatória.');
    if (!form.email_alpha.trim())     return setErroPainel('E-mail corporativo é obrigatório.');
    if (!form.funcao.trim())          return setErroPainel('Função é obrigatória.');
    if (!form.logradouro.trim())      return setErroPainel('Logradouro é obrigatório.');
    if (!form.numero.trim())          return setErroPainel('Número é obrigatório.');
    if (!form.bairro.trim())          return setErroPainel('Bairro é obrigatório.');
    if (!form.municipio.trim())       return setErroPainel('Município é obrigatório.');
    if (!form.uf)                     return setErroPainel('UF é obrigatória.');
    if (!form.cep.trim())             return setErroPainel('CEP é obrigatório.');
    if (!form.ddd.trim())             return setErroPainel('DDD é obrigatório.');
    if (!form.telefone.trim())        return setErroPainel('Telefone é obrigatório.');

    // Validação: se vendedor marcado, comissão é obrigatória e > 0
    if (form.vendedor) {
      const c = parseFloat(form.comissao);
      if (isNaN(c) || c <= 0)
        return setErroPainel('Colaboradores marcados como Vendedor precisam ter Comissão > 0 (cadastre na aba Valores).');
    }

    try {
      setSalvando(true);
      if (painel === 'novo') {
        await colaboradorService.incluir(form);
      } else {
        await colaboradorService.alterar(selecionado.id, form);
      }
      setSucessoPainel(painel === 'novo' ? 'Colaborador incluído com sucesso!' : 'Colaborador alterado com sucesso!');
      await carregar();
      setTimeout(fecharPainel, 1200);
    } catch (err) {
      setErroPainel(err.response?.data?.mensagem || 'Erro ao salvar. Verifique os dados.');
    } finally {
      setSalvando(false);
    }
  };

  const somenteLeitura = painel === 'visualizar';

  // ─── Render ──────────────────────────────────────────────────────────────────
  return (
    <div style={{ fontFamily: "'Manrope', sans-serif" }}>

      {/* r106: BrowseHeader padronizado no topo */}
      <BrowseHeader
        rotina="colaboradores"
        titulo="Colaboradores"
        descricao="Cadastro dos colaboradores da equipe, com função e dados pessoais."
      />

      {/* ── BROWSE ── */}
      <div style={{
        flex: 1, backgroundColor: COR.branco,
        border: `1px solid ${COR.borda}`, borderRadius: '8px',
        overflow: 'hidden', minWidth: 0,
      }}>
        <div style={{
          padding: '14px 16px', borderBottom: `1px solid ${COR.borda}`,
          display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap',
        }}>
          <span style={{ fontSize: '13px', fontWeight: '500', color: COR.muted, flex: 1 }}>
            {listaFiltrada.length} registro{listaFiltrada.length !== 1 ? 's' : ''}
          </span>
          <input
            type="text" placeholder="Pesquisar..."
            value={busca} onChange={e => setBusca(e.target.value)}
            style={{ ...inputStyle, width: '320px' }}
          />
          <SePode rotina="colaboradores" acao="incluir"><BtnIcone icone="incluir" onClick={abrirNovo} title="Incluir novo colaborador" cor={COR.azul} solido tamanho="grande" /></SePode>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ backgroundColor: COR.azul }}>
                {/* r106: 1ª coluna fixa pro ícone SVG da rotina */}
                <th style={{ padding: '10px 14px', width: '36px' }}></th>
                {[
                  { label: 'Nome',     campo: 'nome'        },
                  { label: 'CPF',      campo: 'cpf'         },
                  { label: 'Função',   campo: 'funcao'      },
                  { label: 'E-mail',   campo: 'email_alpha' },
                  { label: 'Status',   campo: 'status'      },
                  { label: 'Ações',    campo: null          },
                ].map(({ label, campo }) => (
                  <th key={label} onClick={() => campo && toggleOrdem(campo)} style={{
                    padding: '10px 14px', textAlign: 'left',
                    fontSize: '13px', fontWeight: '700', color: COR.branco,
                    whiteSpace: 'nowrap', cursor: campo ? 'pointer' : 'default', userSelect: 'none',
                  }}>
                    {label}{campo && setaCabecalho(campo)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {carregando ? (
                <tr><td colSpan="7" style={{ padding: '40px', textAlign: 'center', color: COR.muted }}>Carregando...</td></tr>
              ) : listaFiltrada.length === 0 ? (
                <tr><td colSpan="7" style={{ padding: '40px', textAlign: 'center', color: COR.muted }}>Nenhum colaborador encontrado.</td></tr>
              ) : listaFiltrada.map((c, i) => (
                <tr key={c.id} onClick={() => abrirVisualizar(c)} style={{
                  borderBottom: `1px solid ${COR.borda}`,
                  backgroundColor: selecionado?.id === c.id ? COR.azulBg : i % 2 === 0 ? COR.branco : '#fafafa',
                  cursor: 'pointer',
                }}>
                  {/* r106: ícone SVG #003399 da rotina (mesmo do menu lateral) */}
                  <td style={{ padding: '10px 0 10px 14px', verticalAlign: 'middle' }}>
                    {iconeDaRotina('colaboradores', { width: 20, height: 20, color: COR.azul })}
                  </td>
                  <td style={{ padding: '10px 14px', fontWeight: '500', color: COR.texto }}>
                    {c.nome}
                    <VendedorBadge vendedor={sanitizarVendedor(c.vendedor)} />
                    <RespTecBadge respTec={sanitizarBool(c.resp_tecnico)} />
                  </td>
                  <td style={{ padding: '10px 14px', color: COR.muted }}>{c.cpf}</td>
                  <td style={{ padding: '10px 14px', color: COR.muted }}>{c.funcao}</td>
                  <td style={{ padding: '10px 14px', color: COR.muted }}>{c.email_alpha}</td>
                  <td style={{ padding: '10px 14px' }}><StatusPill status={c.status} /></td>
                  <td style={{ padding: '10px 14px' }}>
                    <div style={{ display: 'flex', gap: '4px' }} onClick={e => e.stopPropagation()}>
                      <SePode rotina="colaboradores" acao="alterar"><BtnIcone icone="alterar" onClick={() => abrirEditar(c)} title="Alterar" cor={COR.azul} /></SePode>
                      <SePode rotina="colaboradores" acao="alterar"><BtnIcone
                        icone={c.status === 'A' ? 'bloquear' : 'desbloquear'}
                        onClick={() => alterarStatus(c)}
                        title={c.status === 'A' ? 'Inativar' : 'Ativar'}
                        cor={c.status === 'A' ? COR.vermelho : COR.verde}
                      /></SePode>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── MODAL ── */}
      <Modal
        aberto={!!painel}
        titulo={painel === 'novo' ? 'Novo Colaborador' : painel === 'editar' ? 'Alterar Colaborador' : 'Visualizar Colaborador'}
        onFechar={fecharPainel}
        onSalvar={salvar}
        salvando={salvando}
        somenteLeitura={somenteLeitura}
        onEditar={() => setPainel('editar')}
        // r129 item 5: header rico com faixa azul, ícone SVG, descrição, botões no topo
        rotina="colaboradores"
        descricao="Cadastro dos colaboradores vinculados a usuários do portal."
        botoesNoTopo={true}
        largura="95vw"
        // r132 item 2: botão "Gerenciar Valores" no header, junto com Cancelar/Salvar
        botoesExtras={
          <button
            type="button"
            onClick={() => setModalValores(true)}
            disabled={!selecionado?.id}
            title={!selecionado?.id ? 'Salve o colaborador antes de gerenciar valores' : 'Abrir tela de Valores'}
            style={{
              // mesmo padding e tamanho dos botões padrão do header (Cancelar: 8px 18px)
              padding: '8px 18px',
              border: `1px solid ${!selecionado?.id ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.5)'}`,
              borderRadius: '5px',
              backgroundColor: 'transparent',
              color: !selecionado?.id ? 'rgba(255,255,255,0.45)' : '#fff',
              fontSize: '13px', fontWeight: '500',
              cursor: !selecionado?.id ? 'not-allowed' : 'pointer',
              fontFamily: "'Manrope', sans-serif",
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              whiteSpace: 'nowrap',
            }}
          >
            <SvgValores size={14} />
            Gerenciar Valores
          </button>
        }
      >
        <div>

            {erroPainel && (
              <div style={{ backgroundColor: COR.vermBg, border: `1px solid #ffcccc`, borderRadius: '5px', color: COR.vermelho, fontSize: '13px', padding: '10px 12px', marginBottom: '12px' }}>
                {erroPainel}
              </div>
            )}
            {sucessoPainel && (
              <div style={{ backgroundColor: COR.verdeBg, border: `1px solid #a8e6c1`, borderRadius: '5px', color: '#1d6a3a', fontSize: '13px', padding: '10px 12px', marginBottom: '12px' }}>
                {sucessoPainel}
              </div>
            )}

            {/* ═══ r129 item 7: Seções expansíveis (modelo Negócios) ═══ */}

            {/* ── SEÇÃO VÍNCULO (fixa, sempre aberta) ─────────────────── */}
            <Secao icone={SvgVinculo} titulo="Vínculo" fixa>
              {/* r130 item 1: dividido em 2 metades - select à esquerda, avatar centralizado na metade direita */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', alignItems: 'start' }}>
                <Campo label="Usuário do Portal" obrigatorio>
                  <select name="usuario_id" value={form.usuario_id || ''} onChange={somenteLeitura ? undefined : handleUsuarioVinculo} disabled={somenteLeitura} style={somenteLeitura ? inputStyle : selectStyle}>
                    <option value="">Selecione o usuário...</option>
                    {form.usuario_id && !usuariosDisp.some(u => u.id === form.usuario_id) && (
                      <option value={form.usuario_id}>
                        {selecionado?.usuario_nome || form.usuario_id} (vinculado)
                      </option>
                    )}
                    {usuariosDisp.map(u => (
                      <option key={u.id} value={u.id}>{u.nome_amigavel} — {u.email}</option>
                    ))}
                  </select>
                </Campo>
                {/* r131 item 4: conjunto alinhado à direita do modal */}
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <AvatarPequeno usuario={usuarioVinculadoCompleto} />
                </div>
              </div>
            </Secao>

            {/* r131 item 1: Dados Pessoais agora expansível (começa aberta) */}
            <Secao icone={SvgPessoa} titulo="Dados Pessoais"
                   aberta={secoes.dadosPessoais}
                   onToggle={() => toggleSec('dadosPessoais')}>
              {/* Linha 1: Nome | Nome amigável */}
              <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: '10px' }}>
                <Campo label="Nome Completo" obrigatorio>
                  <input name="nome" value={form.nome} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Nome completo" />
                </Campo>
                <Campo label="Nome Amigável" obrigatorio>
                  <input
                    name="nome_amigavel" value={form.nome_amigavel} onChange={handleCampo}
                    disabled={somenteLeitura} style={inputStyle}
                    placeholder="Como o colaborador prefere ser chamado"
                    maxLength={40}
                  />
                </Campo>
              </div>

              {/* Linha 2: CPF | Nascimento */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <Campo label="CPF" obrigatorio>
                  <input
                    name="cpf"
                    value={formatarCpf(form.cpf)}
                    onChange={e => setForm(f => ({ ...f, cpf: limparCpf(e.target.value) }))}
                    disabled={somenteLeitura} style={inputStyle}
                    placeholder="000.000.000-00" maxLength={14}
                    inputMode="numeric"
                  />
                </Campo>
                <Campo label="Nascimento" obrigatorio>
                  <input name="nascimento" type="date" value={form.nascimento || ''} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} />
                </Campo>
              </div>

              {/* Endereço: Logradouro | Número | Complemento */}
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 0.6fr 1fr', gap: '10px' }}>
                <Campo label="Logradouro" obrigatorio>
                  <input name="logradouro" value={form.logradouro} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Rua, Av., Travessa..." />
                </Campo>
                <Campo label="Número" obrigatorio>
                  <input name="numero" value={form.numero} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Nº" maxLength={8} />
                </Campo>
                <Campo label="Complemento">
                  <input name="complemento" value={form.complemento} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Apto, Sala..." />
                </Campo>
              </div>

              {/* Bairro | Município | UF | CEP */}
              <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1.2fr 0.5fr 1fr', gap: '10px' }}>
                <Campo label="Bairro" obrigatorio>
                  <input name="bairro" value={form.bairro} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Bairro" />
                </Campo>
                <Campo label="Município" obrigatorio>
                  <input name="municipio" value={form.municipio} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Município" />
                </Campo>
                <Campo label="UF" obrigatorio>
                  <select name="uf" value={form.uf} onChange={handleCampo} disabled={somenteLeitura} style={somenteLeitura ? inputStyle : selectStyle}>
                    <option value="">UF</option>
                    {UFS.map(uf => <option key={uf} value={uf}>{uf}</option>)}
                  </select>
                </Campo>
                <Campo label="CEP" obrigatorio>
                  <input
                    name="cep"
                    value={mascararCep(form.cep)}
                    onChange={e => setForm(f => ({ ...f, cep: limparCep(e.target.value) }))}
                    disabled={somenteLeitura} style={inputStyle}
                    placeholder="99.999-999" maxLength={10}
                  />
                </Campo>
              </div>
            </Secao>

            {/* ── SEÇÃO CONTATO (expansível) ──────────────────────────── */}
            <Secao icone={SvgContato} titulo="Contato" aberta={secoes.contato} onToggle={() => toggleSec('contato')}>
              {/* DDD | Telefone | Email Corporativo | Email Pessoal */}
              <div style={{ display: 'grid', gridTemplateColumns: '0.5fr 1fr 1.5fr 1.5fr', gap: '10px' }}>
                <Campo label="DDD" obrigatorio>
                  <input name="ddd" value={form.ddd} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="41" maxLength={2} />
                </Campo>
                <Campo label="Telefone" obrigatorio>
                  <input
                    name="telefone"
                    value={mascararTelefone(form.telefone)}
                    onChange={e => setForm(f => ({ ...f, telefone: limparTelefone(e.target.value) }))}
                    disabled={somenteLeitura} style={inputStyle}
                    placeholder="9999-9999" maxLength={9}
                  />
                </Campo>
                <Campo label="E-mail Corporativo" obrigatorio>
                  <input name="email_alpha" type="email" value={form.email_alpha} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="nome@alphaerp.com.br" />
                </Campo>
                <Campo label="E-mail Pessoal">
                  <input name="email_pessoal" type="email" value={form.email_pessoal} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="email@pessoal.com" />
                </Campo>
              </div>

              <Campo label="Contato de Emergência">
                <textarea
                  name="contato_emergencia"
                  value={form.contato_emergencia}
                  onChange={handleCampo}
                  disabled={somenteLeitura}
                  style={textareaStyle}
                  placeholder="Nome, parentesco, telefone..."
                />
              </Campo>
            </Secao>

            {/* ── SEÇÃO DADOS FUNCIONAIS (expansível) ─────────────────── */}
            <Secao icone={SvgFuncional} titulo="Dados Funcionais" aberta={secoes.funcionais} onToggle={() => toggleSec('funcionais')}>
              {/* Data Início | Função | Data Fim | Status */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr 1fr', gap: '10px' }}>
                <Campo label="Data Início">
                  <input name="data_inicio" type="date" value={form.data_inicio || ''} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} />
                </Campo>
                <Campo label="Função" obrigatorio>
                  <input name="funcao" value={form.funcao} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Ex: Consultor ERP" />
                </Campo>
                <Campo label="Data Fim">
                  <input name="data_fim" type="date" value={form.data_fim || ''} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} />
                </Campo>
                <Campo label="Status" obrigatorio>
                  <select name="status" value={form.status} onChange={handleCampo} disabled={somenteLeitura} style={somenteLeitura ? inputStyle : selectStyle}>
                    <option value="A">Ativo</option>
                    <option value="I">Inativo</option>
                  </select>
                </Campo>
              </div>

              {/* Perfil: Vendedor + Resp. Técnico */}
              <Campo label="Perfil">
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <label style={{
                    display: 'inline-flex', alignItems: 'center', gap: '8px',
                    fontSize: '13px', color: COR.texto,
                    cursor: somenteLeitura ? 'default' : 'pointer',
                    padding: '8px 12px',
                    border: `1px solid ${form.vendedor ? COR.azul : COR.borda}`,
                    backgroundColor: form.vendedor ? COR.azulBg : COR.branco,
                    borderRadius: '5px',
                    userSelect: 'none',
                    transition: 'all 0.15s',
                  }}>
                    <input
                      type="checkbox"
                      checked={!!form.vendedor}
                      onChange={e => setForm(f => ({ ...f, vendedor: e.target.checked }))}
                      disabled={somenteLeitura}
                      style={{ cursor: somenteLeitura ? 'default' : 'pointer', width: '16px', height: '16px' }}
                    />
                    <span style={{ fontWeight: form.vendedor ? '600' : '400' }}>Vendedor</span>
                  </label>
                  <label style={{
                    display: 'inline-flex', alignItems: 'center', gap: '8px',
                    fontSize: '13px', color: COR.texto,
                    cursor: somenteLeitura ? 'default' : 'pointer',
                    padding: '8px 12px',
                    border: `1px solid ${form.resp_tecnico ? COR.verde : COR.borda}`,
                    backgroundColor: form.resp_tecnico ? COR.verdeBg : COR.branco,
                    borderRadius: '5px',
                    userSelect: 'none',
                    transition: 'all 0.15s',
                  }}>
                    <input
                      type="checkbox"
                      checked={!!form.resp_tecnico}
                      onChange={e => setForm(f => ({ ...f, resp_tecnico: e.target.checked }))}
                      disabled={somenteLeitura}
                      style={{ cursor: somenteLeitura ? 'default' : 'pointer', width: '16px', height: '16px' }}
                    />
                    <span style={{ fontWeight: form.resp_tecnico ? '600' : '400' }}>Responsável Técnico</span>
                  </label>
                </div>
                {form.vendedor && (
                  <div style={{ fontSize: '11px', color: COR.amarelo, marginTop: '6px' }}>
                    ⚠️ Vendedores precisam ter Comissão &gt; 0 (cadastrada na seção Valores).
                  </div>
                )}
                {form.resp_tecnico && (
                  <div style={{ fontSize: '11px', color: COR.verde, marginTop: '4px' }}>
                    💡 Responsáveis Técnicos podem visualizar e editar a quantificação dos projetos em que participam.
                  </div>
                )}
              </Campo>
            </Secao>

            {/* ── SEÇÃO DADOS FINANCEIROS (expansível) ────────────────── */}
            <Secao icone={SvgFinanceiro} titulo="Dados Financeiros" aberta={secoes.financeiros} onToggle={() => toggleSec('financeiros')}>
              {/* Rem Fixa | Vlr Hora | %Comissão (todos read-only — gerenciados pelo modal de Valores) */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
                <Campo label="Rem. Fixa">
                  <input value={form.rem_fixa ? parseFloat(form.rem_fixa).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '—'} disabled style={{ ...inputStyle, backgroundColor: '#fafafa', color: COR.muted }} />
                </Campo>
                <Campo label="Vlr. Hora">
                  <input value={form.vlr_hora ? parseFloat(form.vlr_hora).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '—'} disabled style={{ ...inputStyle, backgroundColor: '#fafafa', color: COR.muted }} />
                </Campo>
                <Campo label="% Comissão">
                  <input value={form.comissao ? parseFloat(form.comissao).toFixed(2) + '%' : '—'} disabled style={{ ...inputStyle, backgroundColor: '#fafafa', color: COR.muted }} />
                </Campo>
              </div>

              {/* r132: botão Gerenciar Valores movido pro header — aviso de orientação aqui */}
              <div style={{ fontSize: '11px', color: COR.muted, marginTop: '-12px', marginBottom: '16px' }}>
                Valores gerenciados pelo botão <b>Gerenciar Valores</b> no topo da tela.
              </div>

              <Campo label="Dados Bancários">
                <textarea
                  name="dados_bancarios"
                  value={form.dados_bancarios}
                  onChange={handleCampo}
                  disabled={somenteLeitura}
                  style={textareaStyle}
                  placeholder="Banco, agência, conta, PIX..."
                />
              </Campo>
            </Secao>
        </div>

        {/* r131 item 3: Modal de Valores sobreposto (renderiza por cima do modal principal) */}
        {modalValores && (
          <Modal
            aberto={modalValores}
            titulo={`Valores — ${form.nome_amigavel || form.nome || 'Colaborador'}`}
            onFechar={() => setModalValores(false)}
            onSalvar={() => setModalValores(false)}
            salvando={false}
            somenteLeitura={somenteLeitura}
            rotina="colaboradores"
            descricao="Gerenciamento de Rem. Fixa, Vlr. Hora e % Comissão históricos do colaborador."
            botoesNoTopo={true}
            largura="90vw"
          >
            <GridValores
              vinculo="C"
              idVinculo={selecionado?.id}
              nome={form.nome}
              somenteLeitura={somenteLeitura}
              onAtualizado={recarregarSelecionado}
            />
          </Modal>
        )}
      </Modal>
    </div>
  );
}

export default ColaboradoresPage;
